import { createStore } from 'vuex'

export default createStore({
  state: {
    // api: 'http://localhost:3100/icollect/',
    api: 'https://nf-api.neutralfuels.net/icollect/',
    nfToken: null,
    user: null,
    versionNumber: 'V 2.0.2',
    sequenceNumber: null,
    maxSequenceNumber: null,
    routeContext: null,
  },
  getters: {

  },
  mutations: {
    SET_TOKEN(state, payload) {
      state.nfToken = payload
      console.debug('NF Token State Change: ', state.nfToken)
    },
    SET_USER(state, payload) {
      state.user = payload
      console.debug("NF User State Change: ", state.user)
    },
    SET_ROUTE_CONTEXT(state, payload) {
      state.routeContext = payload
    },
    CLEAR_ROUTE_CONTEXT(state) {
      state.routeContext = null
    }
  },
  actions: {
  },
  modules: {
  }
})
